<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">
            <div class="row align-items-center text-start">
                <div class="col-7 col-12-narrower">
                    <div class="eyebrow" i18n>Individuelle Webentwicklung</div>
                    <header>
                        <h2 i18n>Webportale für digitale Geschäftsprozesse</h2>
                    </header>
                    <p class="lead" i18n>Wir entwickeln <strong>maßgeschneiderte Webportale und Business-Webanwendungen</strong>, die Informationen, Benutzer und Arbeitsabläufe in einer zentralen Lösung zusammenbringen.</p>
                    <p i18n>Ob Kundenportal, Mitarbeiterportal, Verwaltungsplattform oder branchenspezifische Fachanwendung: AlbCode bildet Ihre Anforderungen passgenau ab, integriert vorhandene Systeme und schafft eine sichere Grundlage für weiteres Wachstum.</p>
                </div>
                <div class="col-5 col-12-narrower">
                    <div class="visual-frame portal-preview">
                        <img src="/referenzen/pzertWebPortal.png" alt="Beispiel eines von AlbCode entwickelten Webportals" i18n-alt />
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container">
        <header class="major text-center">
            <h2 i18n>Webportale, die zu Ihrem Unternehmen passen</h2>
        </header>
        <div class="row features g-4">
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon solid featured fa-users"></span>
                    <h3 i18n>Kunden- und Partnerportale</h3>
                    <p i18n>Geschützte Bereiche für Dokumente, Anfragen, Aufträge, Statusinformationen und die direkte Zusammenarbeit mit Kunden oder Partnern.</p>
                </div>
            </section>
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon solid featured fa-diagram-project"></span>
                    <h3 i18n>Interne Prozessportale</h3>
                    <p i18n>Zentrale Anwendungen für Freigaben, Aufgaben, Datenerfassung und fachliche Abläufe – übersichtlich, nachvollziehbar und rollenbasiert.</p>
                </div>
            </section>
            <section class="col-4 col-12-narrower feature text-start">
                <div class="service-card">
                    <span class="icon solid featured fa-plug"></span>
                    <h3 i18n>Schnittstellen und Integration</h3>
                    <p i18n>Wir verbinden Ihr Portal über APIs mit vorhandener Software, Datenbanken, Buchhaltung, Formularsystemen und weiteren Diensten.</p>
                </div>
            </section>
        </div>
    </section>
</div>

<div class="wrapper">
    <section class="container text-start">
        <div class="row align-items-stretch g-5">
            <div class="col-7 col-12-narrower content-copy">
                <header class="major">
                    <h2 i18n>Von der Idee bis zum stabilen Betrieb</h2>
                </header>
                <p i18n>Wir klären Ziele und Rollen, analysieren die benötigten Prozesse und entwickeln das Portal schrittweise. Moderne Frontends, stabile Backends und eine wartbare Architektur sorgen dafür, dass die Lösung langfristig erweiterbar bleibt.</p>
                <ul class="service-list">
                    <li i18n>Responsive Nutzung auf Desktop, Tablet und Smartphone</li>
                    <li i18n>Sichere Anmeldung sowie rollenbasierte Berechtigungen</li>
                    <li i18n>Individuelle Benutzeroberflächen und Workflows</li>
                    <li i18n>Import, Export und Anbindung bestehender Systeme</li>
                    <li i18n>Wartung, Weiterentwicklung und technischer Betrieb</li>
                </ul>
            </div>
            <div class="col-5 col-12-narrower">
                <div class="visual-frame mb-4">
                    <img src="/freepics/development.jpg" alt="Planung und Entwicklung einer individuellen Webanwendung" i18n-alt />
                </div>
                <div class="callout">
                    <h3 i18n>Sie planen ein Webportal?</h3>
                    <p i18n>Unsere Referenzen zeigen verschiedene Webanwendungen und Integrationen aus der Praxis.</p>
                    <div class="cta-actions">
                        <a routerLink="/albcode/referenzen" class="glow-on-hover p-3" i18n>Referenzen ansehen</a>
                        <a routerLink="/contact" class="glow-on-hover p-3" i18n>Projekt besprechen</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
